import React, { useState } from 'react';
import './switch.css';

const Switch = ({ value, setValue, readOnly = false }) => {


    const toggleSwitch = () => {


        setValue(!value)
    };

    return (
        <label className="switch">
            <input type="checkbox" checked={value} onChange={readOnly ? null : toggleSwitch} />
            <span className="slider"></span>
        </label>
    );
};

export default Switch;
